import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <ul class="items06">
            <!-- The dnd-draggable directive makes an element draggable and will
                 transfer the object that was assigned to it. If an element was
                 dragged away, you have to remove it from the original list
                 yourself using the dnd-moved attribute -->
            <li ng-repeat="(key, item) in vm.models.list">
                <div class="form">
                    <form-row error="vm.form.errors.skills[key].skillId">
                        <label class="label">{{ 'user.Skill' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.form.model.skills[key].skillId">
                                <option value=""></option>
                                <option value="{{ item.id }}" ng-repeat-start="item in vm.skills">
                                   {{ item.name }}
                                </option>
                                <option value="{{ l2item.id }}" ng-repeat-start="l2item in item.children">
                                    &nbsp;&nbsp;{{ l2item.name }}
                                </option>
                                <option value="{{ l3item.id }}" ng-repeat-start="l3item in l2item.children">
                                    &nbsp;&nbsp;&nbsp;{{ l3item.name }}
                                </option>
                                <option value="{{ l4item.id }}" ng-repeat-start="l4item in l3item.children">
                                   &nbsp;&nbsp;&nbsp;&nbsp;{{ l4item.name }}
                                </option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.skills[key].type">
                        <span class="label">{{ 'user.Skill type' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label>
                                        <label><input
                                         ng-model="vm.form.model.skills[key].type"
                                         type="radio"
                                         value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.MANDATORY }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.MANDATORY | translate }}
                                          </label>
                                        <label><input
                                             ng-model="vm.form.model.skills[key].type"
                                             type="radio"
                                             value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.OPTIONAL }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.OPTIONAL }}</label>
                                    </label>
                                </li>
                                <form-row-error></form-row-error>
                            </ul>
                        </div>
                    </form-row>
                    <ul class="actions01">
                        <li><a class="btn delete" ng-click="vm.removeItem(key)">{{ 'general.Remove' | translate }}</a></li>
                    </ul>
                </div>
            </li>
        </ul>
        <ul class="actions01">
            <li><a class="btn add" ng-click="vm.addItem()">{{ 'user.Add skill' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor (SkillResource, USER_COMPETENCE_SKILL_TYPE_ENUM) {
        this.SkillResource = SkillResource;
        this.USER_COMPETENCE_SKILL_TYPE_ENUM = USER_COMPETENCE_SKILL_TYPE_ENUM;
    }

    $onInit () {
        this.models = {};
        this.models.list = [];
        this.form.model.skills = [];
        this.addItem();

        this.SkillResource.tree().$promise.then((skills) => {
            this.skills = skills;
        });
    }

    removeItem (key) {
        if (this.models.list.length > 1) {
            this.models.list.splice(key, 1);
            this.form.model.skills.splice(key, 1);
        }
    }

    addItem () {
        this.models.list.push({});
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/competence/add/skillItem/index.js